module.exports = __webpack_public_path__ + "img/nmi-integration.16ef5c0b.png";